import React from 'react';
import { usePage } from "@inertiajs/react";
import { reduce } from "lodash";
import SelectMulti from "@/User/Components/SelectMulti";

const BusinessSelect = ({ id, values, handleChange }) => {
    const { industryCodeList } = usePage().props;

    const businessOptions = reduce(industryCodeList, (result, industryList) => {
        return {
            ...result,
            ...industryList,
        };
    }, {});

    return (
        <SelectMulti id={id} options={businessOptions} value={values} handleChange={handleChange} placeholder="業種を選ぶ" />
    );
};

export default BusinessSelect;
